export default __webpack_public_path__ + "assets/summit-logo-small.png";